<template>
    <div class="content">
        <div class="page" v-if="pageNow == 1" style="padding-bottom: 60px;">
            <section class="head">
                <section class="flexable center info">
                    <p class="avata flexable">
                        <img :src="userInfo.avatar" alt="">
                    </p>
                    <p class="name">
                        <span>{{ userInfo.nickName }}</span>
                        <em v-if="!ifVip">普通会员</em>
                        <em v-if="ifVip">VIP会员</em>
                    </p>
                    <section class="time_end" v-if="ifVip">会员到期：{{ formatDate(userInfo.vipEndTime, "yyyy-MM-dd") }}
                    </section>
                </section>
                <section class="flexable center vip">
                    <a>会员充值</a>
                    <a :href="'/rank?worktype=' + workType">成绩排行</a>
                </section>
            </section>
            <section class="center select_box">
                <p class="title">考试科类设置</p>
                <section class="flexable select_content">
                    <label>类型</label>
                    <section class="select_c" @change="changeExamType">
                        <select name="select2" v-model="examType">
                            <option value="">考试类目</option>
                            <option v-for="item in examTypeList" :key="item.id" :value="item.id">{{ item.typeName }}
                            </option>
                        </select>
                    </section>
                </section>
                <section class="flexable select_content">
                    <label class="l2">工种</label>
                    <section class="select_c">
                        <select name="select3" v-model="workType" @change="changeWorkType">
                            <option value="">考试工种</option>
                            <option v-for="item in workTypeListData" :value="item.id" :key="item.id" 
                                v-show="item.status==1">{{ item.workName }}</option>

                        </select>
                    </section>
                </section>

            </section>
            <section class="blank2"></section>
            <section class="center  opt1">
                <div class="btn_list1 flexable">
                    <a @click="exam1">顺序练习</a>
                    <a @click="exam5">随机练习</a>
                    <a @click="exam2">错题练习</a>
                    <a @click="exam6">快速读题</a>
                </div>

            </section>
            <section class="center flexable opt2">
                <p class="opt_more flexable">
                    <a @click="exam3">攻坚练习</a>
                    <a @click="exam7">我的错题</a>
                </p>
                <a class="moni" @click="exam4">模拟考试</a>

            </section>
            <section class="footer">
                <p>福州市应急管理协会</p>
                <p>Copyright © 2020 <a href="tel:">联系我们</a></p>
            </section>
        </div>

        <!--顺序练习-->
        <div class="page" v-if="pageNow == 2">
            <div class="weui-flex exam_top">
                <div class="title_name">顺序练习</div>
                <div class="weui-cell_primary count">{{ question_index + 1 }} / {{ quetionList.length }}题</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback()">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="exam_question">
                    <span class="exam_type" v-if="question.questionType == 1">单选题</span>
                    <span class="exam_type" v-if="question.questionType == 0">判断题</span>
                    <span class="exam_type" v-if="question.questionType == 2">多选题</span>
                    <p v-html="returnImg(question.question)"></p>
                </div>

                <div class="box">
                    <van-radio-group v-model="radio">
                        <van-radio class="mt10" icon-size="18px" :name="index" v-for="(item, index) in ansewerList"
                            :key="index" @click="chooseAnser(index)">
                            {{ chars[index] }}、<span v-html="returnChoicImg(item)"></span>
                        </van-radio>
                    </van-radio-group>
                </div>
                <div class="weui-flex exam_tip" v-if="result">
                    <div class="exam_result" v-if="result_detail">回答正确！</div>
                    <div class="exam_result" v-if="!result_detail">回答错误！</div>
                    <div class="exam_answer"><span>试题答案</span></div>
                    <div class="weui-flex exam_choose">
                        <span>正确答案：{{ question.answer }}</span>

                    </div>
                    <div class="weui-flex exam_answer_content" style="display: none">
                        <span>答案解析：</span>答案就是{{ question.answer }}啊！不爽你打我啊！
                    </div>
                </div>
                <div class="weui-flex exam_go">
                    <van-button type="primary" size="small" @click="prev()">上一题</van-button>
                    <van-button type="primary" size="small" @click="showGo=true">跳转</van-button>
                    <van-button type="primary" size="small" @click="next()">下一题</van-button>
                </div>
            </div>

            <van-popup v-model="showGo" position="center" :style="{ height: '20%' ,width:'60%'}" >
                <div style="padding:20px">
                    <van-field v-model="nos" type="number" label="" placeholder="输入跳转序号" />
                    <van-button type="info" block size="normal" @click="goQue">跳转</van-button>
                </div>
                
            </van-popup>
        </div>

        <!--随机练习-->
        <div class="page" v-if="pageNow == 8">
            <div class="weui-flex exam_top">
                <div class="title_name">随机练习</div>
                <div class="weui-cell_primary count">{{ question_index + 1 }} / {{ quetionList.length }}题</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback()">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="exam_question">
                    <span class="exam_type" v-if="question.questionType == 1">单选题</span>
                    <span class="exam_type" v-if="question.questionType == 0">判断题</span>
                    <span class="exam_type" v-if="question.questionType == 2">多选题</span>
                    <p v-html="returnImg(question.question)"></p>
                </div>
                <div class="box">
                    <van-radio-group v-model="radio">
                        <van-radio class="mt10" icon-size="18px" :name="index" v-for="(item, index) in ansewerList"
                            :key="index" @click="chooseAnser(index)">
                            {{ chars[index] }}、<span v-html="returnChoicImg(item)"></span>
                        </van-radio>
                    </van-radio-group>
                </div>
                <div class="weui-flex exam_tip" v-if="result">
                    <div class="exam_result" v-if="result_detail">回答正确！</div>
                    <div class="exam_result" v-if="!result_detail">回答错误！</div>
                    <div class="exam_answer"><span>试题答案</span></div>
                    <div class="weui-flex exam_choose">
                        <span>正确答案：{{ question.answer }}</span>
                    </div>
                    <div class="weui-flex exam_answer_content" style="display: none">
                        <span>答案解析：</span>答案就是{{ question.answer }}啊！不爽你打我啊！
                    </div>
                </div>
                <div class="weui-flex exam_go">
                    <van-button type="primary" size="small" @click="prev()">上一题</van-button>
                    <van-button type="primary" size="small" @click="sure" v-if="question.questionType == 2">确认</van-button>
                    <van-button type="primary" size="small" @click="next()">下一题</van-button>
                </div>
            </div>
        </div>

        <!--错题练习-->
        <div class="page" v-if="pageNow == 5">
            <div class="weui-flex exam_top">
                <div class="title_name">错题练习</div>
                <div class="weui-cell_primary count">{{ question_index + 1 }} / {{ quetionList.length }}题</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback()">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="exam_question">
                    <span class="exam_type" v-if="question.questionType == 1">单选题</span>
                    <span class="exam_type" v-if="question.questionType == 0">判断题</span>
                    <span class="exam_type" v-if="question.questionType == 2">多选题</span>
                    <p v-html="returnImg(question.question)"></p>
                </div>
                <div class="box">
                    <van-radio-group v-model="radio">
                        <van-radio class="mt10" icon-size="18px" :name="index" v-for="(item, index) in ansewerList"
                            :key="index" @click="chooseAnser(index)">
                            {{ chars[index] }}、<span v-html="returnChoicImg(item)"></span>
                        </van-radio>
                    </van-radio-group>
                </div>
                <div class="weui-flex exam_tip" v-if="result">
                    <div class="exam_result" v-if="result_detail">回答正确！</div>
                    <div class="exam_result" v-if="!result_detail">回答错误！</div>
                    <div class="exam_answer"><span>试题答案</span></div>
                    <div class="weui-flex exam_choose">
                        <span>正确答案：{{ question.answer }}</span>
                    </div>
                    <div class="weui-flex exam_answer_content" style="display: none">
                        <span>答案解析：</span>答案就是{{ question.answer }}啊！不爽你打我啊！
                    </div>
                </div>
                <div class="weui-flex exam_go">
                    <van-button type="primary" size="small" @click="prev()">上一题</van-button>
                    <van-button type="primary" size="small" @click="next()">下一题</van-button>
                </div>
            </div>
        </div>
        <!--攻坚练习-->
        <div class="page" v-if="pageNow == 6">
            <div class="weui-flex exam_top">
                <div class="title_name">攻坚练习</div>
                <div class="weui-cell_primary count">{{ question_index + 1 }} / {{ quetionList.length }}题</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback()">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="exam_question">
                    <span class="exam_type" v-if="question.questionType == 1">单选题</span>
                    <span class="exam_type" v-if="question.questionType == 0">判断题</span>
                    <span class="exam_type" v-if="question.questionType == 2">多选题</span>
                    <p v-html="returnImg(question.question)"></p>
                </div>
                <div class="box">
                    <van-radio-group v-model="radio">
                        <van-radio class="mt10" icon-size="18px" :name="index" v-for="(item, index) in ansewerList"
                            :key="index" @click="chooseAnser(index)">
                            {{ chars[index] }}、<span v-html="returnChoicImg(item)"></span>
                        </van-radio>
                    </van-radio-group>
                </div>
                <div class="weui-flex exam_tip" v-if="result">
                    <div class="exam_result" v-if="result_detail">回答正确！</div>
                    <div class="exam_result" v-if="!result_detail">回答错误！</div>
                    <div class="exam_answer"><span>试题答案</span></div>
                    <div class="weui-flex exam_choose">
                        <span>正确答案：{{ question.answer }}</span>
                    </div>
                    <div class="weui-flex exam_answer_content" style="display: none">
                        <span>答案解析：</span>答案就是{{ question.answer }}啊！不爽你打我啊！
                    </div>
                </div>
                <div class="weui-flex exam_go">
                    <van-button type="primary" size="small" @click="prev()">上一题</van-button>
                    <van-button type="primary" size="small" @click="next()">下一题</van-button>
                </div>
            </div>
        </div>

        <!--读题模式-->
        <div class="page" v-if="pageNow == 4">
            <div class="weui-flex exam_top">
                <div class="title_name">读题模式</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="que_list" v-for="(item, index) in quetionList" :key="index">
                    <div class="exam_question">
                        <span class="exam_type" v-if="item.questionType == 1">单选题</span>
                        <span class="exam_type" v-if="item.questionType == 0">判断题</span>
                        <span class="exam_type" v-if="item.questionType == 2">多选题</span>
                        <p>{{ index + 1 }}、{{ item.question }}</p>
                    </div>
                    <div class="weui-flex exam_tip">
                        <div class="weui-flex exam_choose" v-if="item.questionType == 1">
                            <span v-for="(item2, index2) in item.choice.split('~!!~')" :key="index2"
                                v-show="chars[index2] == item.answer" style="color: red">答案：{{ item2 }}</span>
                        </div>
                        <div class="weui-flex exam_choose" v-if="item.questionType == 0">
                            <span style="color: red">答案：{{ item.answer }}</span>
                        </div>
                        <div class="weui-flex exam_choose" v-if="item.questionType == 2">
                            <span>
                                答案：<br /><em v-for="(item2, index2) in item.choice.split('~!!~')" :key="index2"
                                    v-show="getresult(index2, item.answer)" style="color: red;font-style: normal">
                                    {{ item2 }}<br>
                                </em>
                            </span>

                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!--我的错题-->
        <div class="page" v-if="pageNow == 7">
            <div class="weui-flex exam_top">
                <div class="title_name">我的错题</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="weui-cells" style="margin-top: 0px;line-height: 1">
                    <div class="weui-cell">
                        <div class="weui-cell__bd" style="font-size: 14px;color: #666666">清空错题</div>
                        <div class="weui-cell__ft">
                            <van-button type="primary" size="mini" @click="dele_all_error">清空</van-button>
                        </div>
                    </div>
                </div>
                <div class="weui-cells weui-cells_form" style="margin-top: 0px">
                    <div class="weui-cell weui-cell_switch">
                        <div class="weui-cell__bd" style="font-size: 14px;color: #666666">显示所有选项</div>
                        <div class="weui-cell__ft check_switch_box">
                            <!-- <input class="weui-switch" type="checkbox" v-model="show_select" style="height: 26px;border-radius: 13px;"> -->
                            <van-switch v-model="show_select" />
                        </div>
                    </div>
                </div>
                <div class="que_list" v-for="(item, index) in quetionList" :key="index" v-show="geterror(item.id)">
                    <div class="exam_question">
                        <span class="exam_type" v-if="item.questionType == 1">单选题</span>
                        <span class="exam_type" v-if="item.questionType == 0">判断题</span>
                        <span class="exam_type" v-if="item.questionType == 2">多选题</span>
                        <p>{{ index + 1 }}、{{ item.question }}</p>
                    </div>
                    <div class="weui-cells weui-cells_checkbox exam_check" v-if="show_select"
                        style="margin-top: 0px;transition: all .5s">
                        <label v-for="(item, index) in item.choice.split('~!!~')" :key="index"
                            v-show="item.questionType == 1 || item.questionType == 2" class="weui-cell weui-check__label">
                            <div class="weui-cell__bd">
                                <p>{{ chars[index] }}、{{ item }}</p>
                            </div>
                        </label>
                    </div>
                    <div class="weui-flex exam_tip">
                        <div class="weui-flex exam_choose" v-if="item.questionType == 1">
                            <span v-for="(item2, index2) in item.choice.split('~!!~')" :key="index2"
                                v-show="chars[index2] == item.answer" style="color: red">答案：{{ item2 }}</span>
                        </div>
                        <div class="weui-flex exam_choose" v-if="item.questionType == 0">
                            <span style="color: red">答案：{{ item.answer }}</span>
                        </div>
                        <div class="weui-flex exam_choose" v-if="item.questionType == 2">
                            <span>
                                答案：<br /><em v-for="(item2, index2) in item.choice.split('~!!~')" :key="index2"
                                    v-show="getresult(index2, item.answer)" style="color: red;font-style: normal">
                                    {{ item2 }}<br>
                                </em>
                            </span>

                        </div>
                    </div>
                    <div class="weui-flex" style="line-height: 1">
                        <div class="colMain txtRight">
                            <van-button type="primary" size="small" @click="delError(item.id)">错题排除</van-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!--模拟考试-->
        <div class="page" v-if="pageNow == 3">
            <div class="weui-flex exam_top">
                <div class="weui-cell_primary count"><i class="iconfont icon-clock"
                        style="font-size: 17px;margin-right: 10px;"></i>倒计时 {{ m }}:{{ s }}</div>
                <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback()">返回</a>
                </div>
            </div>
            <div class="content_body">
                <div class="exam_question">
                    <span class="exam_type" v-if="question.questionType == 1">单选题</span>
                    <span class="exam_type" v-if="question.questionType == 0">判断题</span>
                    <span class="exam_type" v-if="question.questionType == 2">多选题</span>
                    <p v-html="returnImg(question.question)"></p>
                </div>
                <form id="form1">
                    <div class="weui-cells weui-cells_checkbox exam_check">
                        <label class="weui-cell weui-check__label" v-for="(item, index) in ansewerList" :key="index">
                            <div class="weui-cell__bd">
                                <p>{{ chars[index] }}、<span v-html="returnChoicImg(item)"></span></p>
                            </div>
                        </label>
                    </div>
                </form>

                <div class="weui-flex mock_exam">

                    <a href="javascript:void(0);" class="btnPrev" @click="exam_pre">上一题</a>

                    <span v-for="(item, index) in ansewerList" :key="index" v-show="question.questionType == 1"
                        @click="chooseExamAnser(index)"
                        :class="{ choosed: mock_anser_list[question_index].choose == index }">{{ chars[index] }}</span>


                    <span v-if="question.questionType == 0" @click="chooseExamAnser(0)"
                        :class="{ choosed: mock_anser_list[question_index].choose == 0 }"><van-icon name="success" /></span>
                    <span v-if="question.questionType == 0" @click="chooseExamAnser(1)"
                        :class="{ choosed: mock_anser_list[question_index].choose == 1 }"><van-icon name="cross" /></span>
                    <a href="javascript:void(0);" class="weui-btn weui-btn_primary  btnNext" @click="exam_next">下一题</a>
                </div>
                <div class="exam_over">
                    <span @click="exam_set_tag">
                        <i class="iconfont"
                            :class="{ icon_weigouxuan: !mock_anser.iftag, icon_yigouxuan: mock_anser.iftag }"></i>标记
                    </span>
                    <span class="jj" @click="check_exam">交卷</span>
                    <span @click="exam_mask = true">
                        <i class="iconfont icon-gengduo" style="font-weight: normal;margin-right: 15px"></i>
                        {{ question_index + 1 }}<font style="color: #cccccc">/100</font>
                    </span>

                </div>
                <div class="mock_exam_ist" v-if="exam_mask" @click="exam_mask = !exam_mask">
                    <li v-for="(item, index) in mock_anser_list" :key="index"
                        :class="{ hover: item.choose != 99, tag: item.iftag }" @click="goExamQuetion(index)">{{ index + 1 }}
                    </li>
                </div>
            </div>
            <div class="exam_mask" v-if="exam_mask" @click="exam_mask = !exam_mask"></div>

        </div>
        <div class="page mock_error" v-if="pageNow == 13">
            <div class="content_body">
                <div class="weui-flex exam_top">
                    <div class="title_name">本次错题</div>
                    <div class=""><a href="javascript:;" class="weui-btn weui-btn_default goback" @click="goback">返回</a>
                    </div>
                </div>
                <div class="que_list" v-for="(item, index) in quetionList" :key="index" v-show="filterErr(item.id)">
                    <div class="exam_question">
                        <span class="exam_type" v-if="item.questionType == 1">单选题</span>
                        <span class="exam_type" v-if="item.questionType == 0">判断题</span>
                        <span class="exam_type" v-if="item.questionType == 2">多选题</span>
                        <p>{{ index + 1 }}、{{ item.question }}</p>
                    </div>
                    <div class="weui-cells weui-cells_checkbox exam_check" style="margin-top: 0px;transition: all .5s">
                        <label v-for="(item2, index) in item.choice.split('~!!~')" :key="index"
                            v-show="item.questionType == 1 || item.questionType == 2" class="weui-cell weui-check__label">
                            <div class="weui-cell__bd">
                                <p>{{ chars[index] }}、{{ item2 }}</p>
                            </div>
                        </label>
                    </div>
                    <div class="weui-flex exam_tip">
                        <div class="exam_answer"><span>试题答案</span></div>
                        <div class="weui-flex exam_choose">
                            <span style="color: red">正确答案：{{ item.answer }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getExamTypeList, getWorkTypeList, getQuestionList, saveWrong, saveMockExam, getWrongQuestionList } from '../../api';
import { getUserInfo } from '../../api/custom';
export default {
    data() {
        return {
            workTypeListData:[],
            showGo:false,//显示跳转弹出窗
            nos:null,//跳转序号
            ifVip: false,
            clickExam: false,
            wrongQuetion: [],//攻坚id_list
            pageNow: 1,
            examTypeList: [],
            workTypeList: [],
            quetionList: [],
            wrongQuetionList: [],
            radio: '',
            param5: {
                workType: '',
                questionId: '',
            },
            userInfo: {
                avatar: "",
                nickName: "",
                id: 1
            },

            examType: "",/*类型id*/
            workType: "",/*工种id*/

            question: {
                answer: "",
                choice: '',
                id: '',
                question: '',
                questionType: '',
                questionValue: '',
                status: '',
                workId: '',
            },/*问题内容对象*/
            question_index: "",/*当前第几题*/
            ansewerList: [],/*选项数组*/
            chooseList: [],/*用户多选题选择数组*/
            chars: ["A", "B", "C", "D", "E", "F", "G"],/*选项标记字符数组*/
            result: false,/*是否显示答案*/
            result_detail: false,/*回答是否正确*/
            error_list: [],/*错题列表*/
            show_select: false,/*是否显示问题*/
            clock: '',
            m: 0,/*分钟*/
            s: 0,/*秒秒钟*/
            exam_mask: false,
            error_num: 0,
            true_num: 0,
            null_num: 0,//模拟考空题数

            /*客户模拟考题目选择*/
            mock_anser: {
                id: null,
                choose: 99,
                index: null,
                result: 0,//0为回答错误，1为回答正确
                iftag: false,
            },
            mock_anser_list: [],
            mock_error_list: [],
        }
    },
    created() {
        this.getUser();
    },
    
    mounted() {
       
        if (localStorage.getItem("examType") != null) {
            this.examType = localStorage.getItem("examType")
            console.log(this.examType)
        }
        if (localStorage.getItem("workType") != null) {
           
            this.workType = localStorage.getItem("workType")
            console.log(this.workType)
        }
        if (localStorage.getItem(this.workType + "_que_list") != null) {
            this.quetionList = JSON.parse(localStorage.getItem(this.workType + "_que_list"))
        }
        this.getExamList();
        this.getWorkList();



    },
    computed:{
    //1. 在computed里先做好判断，这里过滤的成本远比v-if的成本低
    ListArr(){
            let that=this
            if(that.examType != ''){
                return this.workTypeList.filter((item) => item.examType === that.examType)
            }else{
                return this.workTypeList
            }
            
        }
    },
    filters: {
        returnResult(item) {
            if (parseInt(item)) {
                var temp = item.split("");
                var str = "";
                temp.forEach(function (value) {
                    str = str + this.chars[value - 1];
                })
                return str;
            } else {
                return item
            }
        },

    },
    watch: {
        question_index() {
            this.question = this.quetionList[this.question_index];
            console.log(this.question)
            if (this.pageNow == 3) {
                this.mock_anser = this.mock_anser_list[this.question_index];
            }
            if (this.question.questionType == 1 || this.question.questionType == 2) {
                this.ansewerList = this.question.choice.split("~!!~");
                if (this.question.questionType == 2) {
                    if (parseInt(this.question.answer)) {
                        var temp = this.question.answer.split("");
                        var str = "";
                        temp.forEach(function (item) {
                            str = str + this.chars[item - 1];
                        })
                        this.question.answer = str;
                    }
                }
            } else {
                this.ansewerList = ["正确", "错误"];
            }

        },
    },
    methods: {
        
        //顺序练习跳转
        goQue(){
            this.showGo=false
            this.question_index= parseInt(this.nos)
            this.nos=null
        },
        getUser() {
            getUserInfo().then(res => {
                console.log(res)
                this.userInfo = res.data.info
            })
        },
        /*存储错题Id_list*/
        storeErrorQuetion() {
            localStorage.setItem(this.workType + "_error_list", JSON.stringify(this.error_list));
        },
        getQuestionList,
        getWorkList() {
            let that=this
            getWorkTypeList().then(res => {
                this.workTypeList = res.data.list
                // console.log(that.examType)
                    
                if(this.examType !='' && this.examType != null){
                    this.workTypeListData=this.workTypeList.filter((item) => item.examType == that.examType)
                    console.log(this.workTypeListData)
                    
                }else{
                    this.workTypeListData=res.data.list
                }
                
            })
            
        },
        getExamList() {
            getExamTypeList().then(res => {
                this.examTypeList = res.data.list
                console.log(this.examTypeList);
            })
        },
        /*该题是否在错误列表*/
        geterror(id) {
            if (this.error_list != null && this.error_list.toString().indexOf(id) != -1) {
                return true;
            } else {
                return false;
            }
        },
        /*选择考试类型*/
        changeExamType() {
            localStorage.setItem("examType", this.examType)
            this.workType =''
            let that=this
            this.workTypeListData=[]
            // this.workTypeListData = this.workTypeListData.concat(this.workTypeList.filter((item) => item.examType === that.examType))
            // this.$set( this.workTypeListData,,true);
            console.log(this.workTypeListData)
            this.$nextTick(()=>{
                that.workTypeListData = that.workTypeListData.concat(that.workTypeList.filter((item) => item.examType === that.examType))
            });
        },
        /*选择工种类目*/
        changeWorkType() {
            //缓存工种类目
            localStorage.setItem("workType", this.workType)
            //判断是否存在缓存题库
            if (localStorage.getItem(this.workType + "_que_list") != null) {
                this.quetionList = JSON.parse(localStorage.getItem(this.workType + "_que_list"))
            } else {
                this.getQuestionList(this.workType).then(res => {
                    this.quetionList = res.data.list
                    //本地缓存试题
                    localStorage.setItem(this.workType + "_que_list", JSON.stringify(res.data.list))
                })
            }

        },
        getStoreQuetionList() {
            this.quetionList = JSON.parse(localStorage.getItem(this.workType + "_que_list"))
        },
        returnImg(html) {
            return (this.question_index + 1) + '、' + html.replace("{ftp_www}/photo/tq/", "/file/")
        },
        returnChoicImg(html) {
            if (html.indexOf("img:") > -1) {
                /*var startIndex = html.indexOf("tq");*/
                var startIndex = html.lastIndexOf("/");
                var endIndex = html.indexOf(".png") > -1 ? html.indexOf(".png") : html.indexOf(".jpg");
                var imgSrc = html.substring(startIndex, endIndex + 4);
                //return "<img src=\"/file"+imgSrc+"\"width=\"50px\" \/>"
                return '<img src=http://api.fzsyjxh.com/file' + imgSrc + 'width=50 />'
            } else {
                return html
            }
        },
        // 顺序练习
        exam1() {
            if (this.workType == '') {
                alert("请选择工种");
                return;
            }
            this.pageNow = 2;
            if (!this.getStoreQuetionIndex()) {
                this.question_index = 0;
            } else {
                this.question_index = this.getStoreQuetionIndex();
            }
            // this.question_index = 0;
            
        },
        /*随机练习*/
        exam5() {
            let vm = this
            if (this.workType == '') {
                alert("请选择工种")
                return;
            }
            vm.pageNow = 8;
            vm.quetionList = vm.shuffle(vm.quetionList);
            vm.question_index = 0;

        },
        /*错题练习*/
        exam2() {
            let vm = this
            if (this.workType == '') {
                alert("请选择工种");
                return
            }
            if (vm.getStoreErrorQuetion()) {
                vm.question_index = 0;
                vm.pageNow = 5;
            } else {
                alert("暂无错题");
            }
        },
        /*攻坚练习*/
        exam3() {
            if (this.workType == '') {
                alert("请选择工种");
                return;
            }
            this.pageNow = 6;
            this.getAttackList();

        },
        /*模拟考试*/
        exam4() {
            let vm = this
            if (this.workType == '') {
                alert("请选择工种");
                return;
            }
            vm.pageNow = 3;
            vm.generateExamList();
            vm.question_index = 0;
            vm.m = 110;
            vm.s = 60;
            vm.showtime();
            for (var j = 0; j < vm.quetionList.length; j++) {
                var mock_anser = {}
                mock_anser.id = vm.quetionList[j].id;
                mock_anser.result = 0;
                mock_anser.iftag = false;
                mock_anser.choose = 99;
                vm.mock_anser_list[j] = mock_anser;
            }

        },
        /*模拟考试选择答案*/
        chooseExamAnser: function (index) {
            let vm = this
            let mock_anser = vm.mock_anser_list[vm.question_index];
            mock_anser.choose = index;
            if (this.question.questionType == 0) {
                if (this.ansewerList[index] == this.question.answer) {
                    mock_anser.result = 1;
                } else {
                    if (this.error_list.toString().indexOf(this.question.id) < 0) {
                        //this.up_error();
                        this.error_list.push(this.question.id);
                        this.storeErrorQuetion();
                    }
                }
            } else if (this.question.questionType == 1) {
                if (this.chars[index] == this.question.answer) {
                    mock_anser.result = 1;
                } else {
                    if (this.error_list.toString().indexOf(this.question.id) < 0) {
                        //this.up_error();
                        this.error_list.push(this.question.id);
                        this.storeErrorQuetion();
                    }
                }
            }
            else if (this.question.questionType == 2) {
                var num = this.chooseList.indexOf(vm.chars[index]);
                if (num > -1) {
                    this.chooseList.splice(num, 1)
                } else {
                    this.chooseList.push(vm.chars[index]);
                }
            }

        },
        /*快速读题*/
        exam6() {
            if (this.workType == '') {
                alert("请选择工种");
                return;
            }
            this.pageNow = 4;


        },
        /*我的错题*/
        exam7() {
            if (this.workType == '') {
                alert("请选择工种");
                return;
            }

            this.getStoreErrorQuetion();
            this.pageNow = 7;

        },
        /*获得之前做到的第几题*/
        getStoreQuetionIndex() {
            if (localStorage.getItem(this.workType + "_" + this.pageNow + "_now_index") == null) {
                return false
            } else {
                return parseInt(localStorage.getItem(this.workType + "_" + this.pageNow + "_now_index"));
            }

        },
        /*存储做到的第几题*/
        storeQuetionIndex() {
            localStorage.setItem(this.workType + "_" + this.pageNow + "_now_index", this.question_index);
        },
        /*用户选择答案*/
        chooseAnser(index) {
            console.log(index);
            if (this.question.questionType == 0) {
                this.result = true;
                if (this.ansewerList[index] == this.question.answer) {
                    this.result_detail = true;
                } else {
                    if (this.error_list.toString().indexOf(this.question.id) < 0) {
                        this.up_error();
                        this.error_list.push(this.question.id);
                        this.storeErrorQuetion();
                    }
                }
            } else if (this.question.questionType == 1) {
                this.result = true;
                if (this.chars[index] == this.question.answer) {
                    this.result_detail = true;
                } else {
                    if (this.error_list.toString().indexOf(this.question.id) < 0) {
                        this.up_error();
                        this.error_list.push(this.question.id);
                        this.storeErrorQuetion();
                    }
                }
            } else if (this.question.questionType == 2) {
                var num = this.chooseList.indexOf(this.chars[index]);
                if (num > -1) {
                    this.chooseList.splice(num, 1)
                } else {
                    this.chooseList.push(this.chars[index]);
                }
            }

        },
        /*上一题*/
        prev() {
            if (this.question_index == 0) {
                return;
            }
            this.question_index--;
            this.result_detail = false;
            this.result = false;
            this.radio = ''
            this.storeQuetionIndex();
        },
        /*下一题*/
        next() {
            if (this.question_index == this.quetionList.length - 1) {
                return
            }
            this.question_index++;
            this.result_detail = false;
            this.result = false;
            this.radio = ''
            this.storeQuetionIndex();
        },
        /*多选确认答案*/
        sure() {
            this.result = true;
            var arr_anser = this.question.answer.split("");
            if (this.checkArray(arr_anser, this.chooseList)) {
                this.result_detail = true;
                if (this.pageNow == 3) {
                    this.true_num = this.true_num + 1;
                    this.exam_next();
                }
            } else {
                if (this.pageNow == 3) {
                    this.error_num = this.error_num + 1;
                    this.exam_mask = true;
                }
                if (this.error_list.toString().indexOf(this.question.id) < 0) {
                    this.error_list.push(this.question.id);
                    this.up_error();
                    this.storeErrorQuetion();
                }
            }
        },

        /*模拟考试下一题*/
        exam_next() {
            if (this.question_index == this.quetionList.length - 1) {
                return
            }
            this.question_index++;
        },
        /*模拟考试上一题*/
        exam_pre() {
            if (this.question_index == 0) {
                return
            }
            this.question_index--;
        },
        /*模拟考试错误遮罩下一题*/
        exam_mask_next() {
            this.question_index++;
            this.exam_mask = false;
            this.result_detail = false;
            this.result = false;
            //$("#form1")[0].reset();
        },

        /*返回主页*/
        goback() {
            if (this.pageNow == 3) {
                clearInterval(this.clock);
                this.error_num = 0;
                this.true_num = 0;
                this.result = false;
                this.alert_if = false;
            }
            this.radio = '';
            this.result = false;
            this.pageNow = 1;
            this.getStoreQuetionList()
        },
        /*模拟考试标志*/
        exam_set_tag() {
            this.mock_anser.iftag = !this.mock_anser.iftag;
            this.mock_anser_list[this.question_index] = this.mock_anser;
        },

        /*获得错题ID_list*/
        getStoreErrorQuetion() {
            var vm = this;
            vm.error_list = JSON.parse(localStorage.getItem(this.workType + "_error_list"));
            if (vm.error_list == "" || vm.error_list == null) {
                vm.error_list = []
            }
            var error_index_list = [];
            if (vm.quetionList.length > 0) {
                vm.quetionList.forEach(function (item) {
                    if (vm.error_list && vm.error_list.toString().indexOf(item.id) > -1) {
                        error_index_list.push(item);
                    }
                });
            }
            if (error_index_list.length < 1) {
                return false;
            } else {
                vm.quetionList = error_index_list;
                return true
            }

        },
        /*模拟考试显示时间*/
        showtime() {
            let vm = this
            this.clock = setInterval(function () {
                vm.s = vm.s - 1;
                if (vm.s == 0) {
                    if (vm.m != 0) {
                        vm.m = vm.m - 1;
                        vm.s = 60
                    }
                }
            }, 1000);


        },
        /*数组比较*/
        checkArray(arr1, arr2) {
            console.log(arr1);
            console.log(arr2);
            if (arr1.length != arr2.length) {
                return false;
            }
            var b = true;
            for (var i = 0, l = arr1.length; i < l; i++) {
                if (arr1.indexOf(arr2[i]) < 0) {
                    b = false;
                }
            }
            return b;
        },
        /*获得答案内容*/
        getresult(index, answer) {
            if (parseInt(answer)) {
                var temp = answer.split("");
                if (temp.indexOf(index + 1 + "") > -1) {
                    return true
                }
            } else {
                return false
            }
        },
        /*排除错题*/
        delError(id) {
            let vm = this
            vm.error_list.forEach(function (value, index) {
                if (value == id) {
                    vm.error_list.splice(index, 1);
                    vm.quetionList.splice(index, 1);
                    vm.storeErrorQuetion();
                    vm.getQuestionList();
                    vm.getStoreErrorQuetion();
                    vm.question_index = 0;
                }

            });
        },
        /*清空错题*/
        dele_all_error() {
            let vm = this
            vm.error_list = [];
            vm.quetionList = [];
            vm.storeErrorQuetion();
            vm.exam7();
        },
        /*post错题记录*/
        up_error() {
            let vm = this;
            console.log(vm.workType)
            vm.param5.workType = parseInt(vm.workType);
            vm.param5.questionId = vm.question.id;
            saveWrong(vm.param5).then(res => {
                if (res.success) {
                    console.log("添加成功")
                }
            })
        },
        postError() {
            alert("提交成功")
        },

        /*获得攻坚练习ID_list*/
        getAttackList() {
            var vm = this;
            var promise = new Promise(function (resolve) {

                getWrongQuestionList(vm.workType).then(res => {
                    res.data.list.forEach(function (item) {
                        vm.wrongQuetion.push(item.questionId);
                    })
                    resolve()
                })

            })
            promise.then(function () {
                vm.getAttack();
            })

        },
        /*获得攻坚练习问题列表*/
        getAttack() {
            let vm = this
            var tempList = [];
            vm.quetionList.forEach(function (item) {
                if (vm.wrongQuetion.toString().indexOf(item.id) > -1) {
                    tempList.push(item);
                }
            });
            vm.quetionList = tempList;
            vm.question_index = 0;
        },
        /*生成考试题目*/
        generateExamList() {
            var examList = [];
            var judge = [];
            var selection = [];
            this.quetionList.forEach(function (item) {
                if (item.questionType == 0) {
                    judge.push(item);
                }
                if (item.questionType == 1) {
                    selection.push(item)
                }
            });
            judge = this.shuffle(judge).slice(0, 70);
            selection = this.shuffle(selection).slice(0, 30);
            examList = examList.concat(judge).concat(selection);
            console.log(examList);
            this.quetionList = examList;
        },
        /*交卷前检查*/
        check_exam() {
            console.log("开始交卷")
            let vm = this
            vm.null_num = 0;
            vm.true_num = 0;
            vm.mock_error_list = [];
            for (var i = 0; i < vm.mock_anser_list.length; i++) {
                if (vm.mock_anser_list[i].choose == 99) {
                    vm.null_num++;
                }
                if (vm.mock_anser_list[i].result > 0) {
                    vm.true_num++;
                }
                if (vm.mock_anser_list[i].choose != 99 && vm.mock_anser_list[i].result == 0) {
                    vm.mock_error_list.push(vm.mock_anser_list[i].id)
                }
            }
            if (vm.null_num > 0) {
                this.$dialog({
                    title: "温馨提示",
                    showCancelButton: 'true',
                    message: "您还有" + vm.null_num + "道题未答题，确认交卷吗?",
                    cancelButtonText: "继续答题",
                    cancelButtonColor: '#000000',
                    confirmButtonText: '确认交卷'
                }).then(() => {
                    vm.up_exam();
                }).catch(() => {
                    console.log('点击了取消')
                })
                // vm.alert_if = true;
                // vm.alert_title = "温馨提示";
                // vm.alert_content ="您还有"+vm.null_num+"未做，确认交卷吗?";
                // vm.alert_btn1 = "继续答题";
                // vm.alert_btn2 = "确认交卷";
                // vm.alert_type = 1;
            } else {
                vm.up_exam();
            }
        },
        shuffle(array) {
            var tmp, current, top = array.length;
            if (top) while (--top) {
                current = Math.floor(Math.random() * (top + 1));
                tmp = array[current];
                array[current] = array[top];
                array[top] = tmp;
            }
            return array;
        },
        /*模拟考试交卷*/
        up_exam() {
            var vm = this;
            let param = {
                //userId : vm.userInfo.id,
                userId: 1,
                workType: vm.workType,
                score: vm.true_num
            }
            saveMockExam(param).then(res => {
                if (res.success) {
                    let content = ""
                    if (vm.true_num >= 80) {
                        content = "您本次考试得分是：" + vm.true_num + "，恭喜！考试合格";
                    } else {
                        content = "您本次考试得分是：" + vm.true_num + "，很遗憾！考不试合格";
                    }
                    this.$dialog({
                        title: "交卷成功",
                        showCancelButton: 'true',
                        message: content,
                        cancelButtonText: "查看错题",
                        cancelButtonColor: '#000000',
                        confirmButtonText: '返回主页'
                    }).then(() => {
                        vm.goback();
                    }).catch(() => {
                        vm.pageNow = 13;
                        console.log('点击了取消')
                    })
                    // vm.alert_if = true;
                    // vm.alert_title = "交卷成功";


                    // vm.alert_btn1 = "查看错题";
                    // vm.alert_btn2 = "返回主页";
                    // vm.alert_type = 2;
                }

            })

        },
        /*模拟考错题过滤*/
        filterErr(id) {
            let vm = this
            var b = false
            vm.mock_error_list.forEach(function (t) {
                if (t == id) {
                    b = true
                }
            })
            return b;
        },
        /*模拟考试跳转*/
        goExamQuetion(index) {
            this.question_index = index;
        },

        /*统计详情*/
        getcount() {
            this.alert_if = true;
            this.alert_title = "统计详情";
            if (this.userInfo.answerNum) {
                this.alert_content = "共回答：" + this.userInfo.answerNum + ",答错" + this.userInfo.wrongNum + "继续努力!"
            } else {
                this.alert_content = "暂无统计记录"
            }


        },

        onClickLeft() {
            this.$router.back()
        },
        onClickRight() {
            this.$router.push("/online")
        },
    }

};
</script>

<style>
.weui-flex {
    display: flex;
}

* {
    box-sizing: border-box;
}

.txtRight {
    text-align: right;
    padding-right: 15px;
}

.colMain {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.box {
    padding: 15px;
    font-size: 14px;
}

.mt10 {
    margin-top: 10px;
}

em,
i {
    font-style: normal;
}

.content,
.page {
    position: absolute;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
}

.page {
    overflow: auto;
    transition: all .5s;
    position: absolute;
    top: 0px;
    right: 0;
    bottom: 0
}

.btn1 {
    display: inline-block;
    width: 100%;
    height: 45px;
}

.btn_list {
    flex-wrap: wrap;
    padding: 0px 15px;
    background: #ffffff;
    margin-top: 13px;
    position: relative
}

.btn_list a {
    position: relative;
    width: 25%;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    color: #333333;
    font-size: 14px;
}

.check_switch_box input:after {
    width: 24px;
    height: 24px;
    border-radius: 12px;
}

.check_switch_box input:before {
    width: 24px;
    height: 24px;
    border-radius: 12px;
}

.weui-switch:checked:after,
.weui-switch-cp__input:checked~.weui-switch-cp__box:after {
    -webkit-transform: translateX(26px);
    transform: translateX(26px);
}

.weui-cells {
    margin-top: 1.17647059em;
    background-color: #FFFFFF;
    line-height: 1.47058824;
    font-size: 17px;
    overflow: hidden;
    position: relative;
}

.weui-cell {
    padding: 10px 15px;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.weui-cell__bd {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.weui-cells_checkbox .weui-cell__hd {
    padding-right: 0.35em;
}

.user_info img {
    width: 72px;
    height: 72px;
}

.page p {
    font-size: 16px;
    margin: 0
}

.page .green {
    color: #1aad19
}

.user_info .wechat {
    font-size: 15px;
    color: #999999;
}

.page .title {
    line-height: 40px;
    padding-left: 15px;
}

.page select {
    color: #666666;
    font-size: 16px;
    direction: rtl;
}

.page label {
    color: #333333;
    font-size: 16px;
    box-sizing: border-box;
}

.footer {
    width: 100%;
    font-size: 14px;
    margin-top: 10px;
}

.footer p {
    font-size: 14px;
}

.footer p a {
    color: #808080;
}

.exam_top {
    width: 100%;
    justify-content: space-between;
    padding: 5px 15px;
    box-sizing: border-box;
    background-color: #fff;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 99;
    display: flex;
}

.page a.goback {
    padding: 0px 10px;
    font-size: 14px;
    line-height: 1.8;
    color: #666666;
}

.exam_top .title_name {
    color: #666666;
    font-size: 14px;
}

.exam_top .count {
    font-size: 16px;
    font-weight: bold;
    color: #3366CC;
    flex: 1;
    text-align: center
}

.exam_question {
    padding: 15px;
    justify-content: flex-start;
    background-color: #f8f8f8;
}

.exam_question .exam_type {
    float: left;
    background-color: #1aad19;
    color: #fff;
    padding: 2px 10px;
    font-size: 13px;
    margin-right: 5px;
}

.exam_check label {
    border: none
}

.exam_check.weui-cells:after,
.exam_check.weui-cells:before {
    border: none
}

.exam_check label:before {
    border: none
}

.exam_go {
    justify-content: space-between;
    padding: 46px 15px;
    position: fixed;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    bottom: 0px;
    left: 0px;
    z-index: 99;
    background: #ffffff
}

.exam_go a {
    font-size: 18px;
    width: 96px;
    text-align: center;
    box-sizing: border-box;
    line-height: 38px;
    margin: 0px;
}

.exam_go .weui-btn+.weui-btn {
    margin-top: 0px
}

.exam_tip {
    flex-wrap: wrap;
    padding: 0px 15px;
    margin-top: 20px;
}

.exam_tip .exam_result {
    color: red;
    font-weight: bold
}

.exam_tip .exam_answer {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

.exam_tip .exam_answer span:before {
    height: 1px;
    width: 33%;
    border-top: 1px solid #808080;
    content: "";
    position: absolute;
    top: 12px;
    left: 0px
}

.exam_tip .exam_answer span:after {
    height: 1px;
    width: 33%;
    border-top: 1px solid #808080;
    content: "";
    position: absolute;
    top: 12px;
    right: 0px
}

.exam_tip .exam_choose {
    font-size: 16px;
    justify-content: space-between;
    margin-top: 20px;
}

.exam_tip .exam_choose a {
    line-height: 20px;
    padding: 2px 15px;
    margin: 0px;
}

.exam_tip .exam_answer_content {}

.exam_tip>div {
    width: 100%;
}

.que_list p {
    text-align: justify;
}

.que_list .exam_tip {
    margin-top: 0px;
}

.que_list {
    margin-top: 10px
}

.que_list:nth-child(1) {
    margin-top: 0px
}

.content_body {
    margin-top: 35px;
    overflow: scroll;
    height: 100%;
    padding-bottom: 130px;
}


.exam_over {
    padding: 8px 15px;
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    /*overflow: hidden;*/
    height: 50px;
    box-sizing: border-box;
    z-index: 5;
    display: flex;
    align-items: center;
}

.exam_over:before {
    content: " ";
    position: absolute;
    left: 15px;
    bottom: 49px;
    right: 15px;
    height: 1px;
    border-bottom: 1px solid #000000;
    color: #D9D9D9;
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}

.exam_over span {
    width: 30%;
    font-size: 16px;
    float: left;
    color: #333333;
    text-align: center
}

.exam_over span:first-child {
    width: 30%;
    display: inline-flex;
    align-items: center;
}

.exam_over span:last-child {
    width: 30%;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
}

.exam_over span i {
    font-size: 20px;
    color: #323232;
}

.exam_over span i.iconfont {
    margin-right: 20px
}

.exam_over span.jj {
    width: 28%;
    font-size: 14px;
    text-align: center;
    box-sizing: border-box;
    background: #3366CC;
    color: #ffffff;
    border-radius: 4px;
    line-height: 33px;
}

.exam_over span.jj .circle_top {
    border-top: 2px solid #000000;
    width: 80px;
    height: 80px;
    text-align: center;
    display: inline-block;
    box-sizing: border-box;
    border-radius: 50%;
    position: relative;
    z-index: 8088888;
    background: #fff;
}

.exam_over span em {
    font-size: 18px;
    color: #fff;
    background: #3366CC;
    border-radius: 50%;
    display: inline-block;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-style: normal;
    margin-top: 10px;
    z-index: 10
}

.center {
    margin: 0 auto
}

.flexable {
    display: flex;
    justify-content: space-between;
    align-items: center
}

select {
    text-decoration: none;
    border: none;
    background: url("../../asset/images3/right.png") right center no-repeat;
    padding-right: 15px;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    font-size: 14px;
    color: #666666;
    background-size: 6px 9px;
    text-align: right;
}

.blank2 {
    background: #f2f2f2;
    width: 100%;
    height: 10px;
}

.head {
    background: url("../../asset/images3/top_bg.jpg") no-repeat;
    background-size: 100% 245px;
    width: 100%;
    height: 208px;
}

.top {
    width: 100%;
    height: 37px;
    padding: 0 15px
}

.top span {
    color: #ffffff;
    background: url("../../asset/images3/close.png") left center no-repeat;
    background-size: 12px 12px;
    font-size: 15px;
    padding-left: 16px;
}

.top img {
    width: 16px;
}

.info {
    width: 100%;
    justify-content: flex-start;
    padding: 20px 15px 0;
}

.info .avata {
    padding: 5px;
    background: #9bddea;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
}

.avata img {
    width: 68px;
    height: 68px;
    border-radius: 50%;
}

.page p.name {
    margin-left: 15px;
}

.name span {
    display: block;
    font-size: 15px;
    color: #ffffff;
    background: url("../../asset/images3/head_icon.png") left center no-repeat;
    background-size: 15px 16px;
    padding-left: 22px;
    line-height: 32px;
}

.name em {
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    width: 68px;
    line-height: 23px;
    background: rgba(0, 0, 0, .2);
    display: inline-block;
    border-radius: 9px;
}

.time_end {
    position: absolute;
    font-size: 14px;
    color: #ffffff;
    right: 15px;
    margin-top: 35px;
}

.vip {
    width: 347px;
    height: 76px;
    background: #ffffff;
    border-radius: 10px;
    margin-top: 18px;
    align-items: center;
}

.vip a {
    width: 50%;
    text-align: center;
    font-size: 15px;
    color: #333333;
    padding-top: 30px;
    height: 50px;
}

.vip a:first-child {
    background: url("../../asset/images3/vip.png") center top no-repeat;
    background-size: 26px 22px;
}

.vip a:last-child {
    background: url("../../asset/images3/rang.png") center top no-repeat;
    background-size: 23px;
}

.select_box {
    width: 100%;
    padding: 0 15px 10px;
}

.select_content {
    justify-content: space-between;
    width: 100%;
    height: 31px;
    padding-left: 10px;
    padding-bottom: 10px;
    margin-top: 10px;
}

.select_content:last-child {
    border: none
}

.select_content label {
    background: url("../../asset/images3/type.png") left center no-repeat;
    background-size: 19px 20px;
    padding-left: 28px;
    font-size: 15px;
}

.select_content label.l2 {
    background: url("../../asset/images3/type2.png") left center no-repeat;
    background-size: 19px 20px;
}

.select_c {
    width: 3px;
}

.select_c select {
    float: right;
    font-size: 14px;
}

.page .title {
    font-size: 16px;
    color: #666666;
    margin-left: 10px;
    line-height: 45px;
    padding-left: 0
}

.opt1 {
    width: 100%;
    padding: 0 15px
}

.btn_list1 {
    width: 100%;
    justify-content: space-between;
    padding: 20px 0 15px 0;
    border-bottom: 1px solid #eeeeee;
}

.opt1 a {
    font-size: 14px;
    color: #333333;
    padding-top: 32px;
    width: 25%;
    text-align: center;
}

.opt1 a:first-child {
    background: url("../../asset/images3/icon1.png") center top no-repeat;
    background-size: 26px 24px;
}

.opt1 a:nth-child(2) {
    background: url("../../asset/images3/icon2.png") center top no-repeat;
    background-size: 26px 24px;
}

.opt1 a:nth-child(3) {
    background: url("../../asset/images3/icon3.png") center top no-repeat;
    background-size: 25px 24px;
}

.opt1 a:nth-child(4) {
    background: url("../../asset/images3/icon4.png") center top no-repeat;
    background-size: 26px 24px;
}

.opt2 {
    width: 100%;
    justify-content: center;
    padding: 0 15px;
}

.opt2 .moni {
    width: 57%;
    background: url("../../asset/images3/icon7.png") center 10px no-repeat;
    background-size: 130px 130px;
    text-align: center;
    color: #333333;
    font-size: 15px;
    padding-top: 150px;
    height: 194px;
}

.opt2 .opt_more {
    width: 43%;
    height: 194px;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;
    border-right: 1px solid #ebebeb
}

.opt2 .opt_more a {
    width: 100%;
    padding-top: 40px;
    line-height: 30px;
    font-size: 14px;
    color: #333333;
    text-align: center;
}

.opt2 .opt_more a:first-child {
    background: url("../../asset/images3/icon5.png") top center no-repeat;
    background-size: 40px 40px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebebeb;
    margin-top: 18px;
}

.opt2 .opt_more a:last-child {
    background: url("../../asset/images3/icon6.png") top center no-repeat;
    background-size: 40px 40px;
    margin-top: 10px
}

.footer {
    background: #4d7df9;
    height: 62px;
    padding: 10px 0;
    position: fixed;
    width: 100%;
    bottom: 0;
}

.footer p {
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    line-height: 21px;
}

.footer p a {
    display: inline-block;
    background: #f9a83c;
    text-align: center;
    width: 60px;
    height: 21px;
    border-radius: 5px;
    color: #ffffff;
}

.vip_head {
    padding: 25px 15px 0;
}

.vip_head img {
    width: 100%;
}

.vipList {
    padding: 0 15px;
    margin-top: 10px;
}

.vipList .vip_tit {
    font-size: 14px;
    color: #666666;
    height: 40px;
    line-height: 40px;
}

.vipli {
    border-bottom: 1px solid #e5e5e5;
    padding: 0 10px 12px;
    justify-content: space-between;
    margin-top: 17px;
}

.vip_left {
    display: inline-flex;
    align-items: center;
}

.vip_left img {
    width: 33px;
    height: 32px;
}

.vip_left p {
    font-size: 12px;
    color: #666666;
    margin-left: 6px
}

.vip_left p span:first-child {
    display: block;
    font-size: 14px;
    color: #333333
}

.vip_right {
    color: #808080;
    font-size: 10px;
    margin-right: 10px;
}

.vip_right em {
    color: #333333;
    font-size: 16px;
    margin: 0 4px
}

.buy_btn {
    width: 100%;
    padding: 25px 25px;
}

.buy_btn a {
    display: block;
    text-align: center;
    line-height: 37px;
    height: 37px;
    background: #04b8ae;
    color: #ffffff;
    border-radius: 5px;
    font-size: 14px;
}


.mock_exam {
    justify-content: space-between;
    align-items: center;
    padding: 0px 15px;
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    bottom: 62px;
    display: flex;
}

.mock_exam a {
    font-size: 16px;
    width: 65px;
    text-align: center;
    box-sizing: border-box;
    margin: 0px;
    padding: 0px;
}

.mock_exam span {
    font-size: 18px;
    text-align: center;
    box-sizing: border-box;
    margin: 0px;
    padding: 10px;
    background: #f8f8f8;
    color: #333333;
    border-radius: 5px;
}

.mock_exam span i {
    font-weight: bold
}

.mock_exam span.choosed {
    background: #3366CC;
    color: #ffffff
}

.mock_exam_ist {
    position: fixed;
    width: 300px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -150px;
    padding: 10px;
    box-sizing: border-box;
    flex-wrap: wrap;
    border: 1px solid #f8f8f8;
    overflow: scroll;
    z-index: 100;
    background: #ffffff;
    border-radius: 10px;
}

.mock_exam_ist li {
    background: #f8f8f8;
    box-sizing: border-box;
    border-radius: 5px;
    color: #333333;
    list-style: none;
    display: inline-block;
    text-align: center;
    width: 50px;
    text-align: center;
    margin-top: 10px;
    line-height: 28px;
}

.mock_exam_ist li.hover {
    background: #2D93CA;
    color: #ffffff;
}

.mock_exam_ist li.tag {
    background: #2D93CA;
    color: red;
}

.mock_error {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
}

.exam_mask {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    top: 0px;
    left: 0px;
    background: rgba(3, 3, 3, .5);
    z-index: 99;
}
</style>

